import type { Metadata } from '@lumapps/metadata/types';
import type { MetadataReference } from '@lumapps/widget-base/types';

import type { MetadataMap, TranslateFn } from '../types';
import { transformMetadataToReferences } from './transformMetadata';

/**
 * Filters metadata for a specific community based on its metadata IDs
 */
export const getMetadataForCommunity = (
    communityMetadataIds: string[],
    metadataMap: MetadataMap,
    translate: TranslateFn,
): MetadataReference[] => {
    if (!communityMetadataIds || communityMetadataIds.length === 0) {
        return [];
    }

    const metadataList = communityMetadataIds
        .map((id) => metadataMap.get(id))
        .filter((metadata): metadata is Metadata => metadata !== undefined);

    return transformMetadataToReferences(metadataList, metadataMap, translate);
};
